import { render, staticRenderFns } from "./DashboardTenantsSummary.vue?vue&type=template&id=3e9cb71e&scoped=true&"
import script from "./DashboardTenantsSummary.vue?vue&type=script&lang=js&"
export * from "./DashboardTenantsSummary.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTenantsSummary.vue?vue&type=style&index=0&id=3e9cb71e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9cb71e",
  null
  
)

export default component.exports